<template>
  <div class="app-container">
    <MembershipSubscriptionFilter />
    <MembershipSubscriptionsTable />
    <pagination v-show="total>0" @pagination="fetchData" />
    <el-dialog :title="getTitle" :visible="isSubscriptionVisible" :lock-scroll="false" @close="onCloseDialog()" :width="widthResize" class="modal-center" top="0" >
      <modal ref="memberSubscriptionModal"/>
    </el-dialog>
  </div>
</template>

<script>
import MembershipSubscriptionFilter from '././membership_subscriptions/Filter'
import MembershipSubscriptionsTable from '././membership_subscriptions/Table'
import Modal from '././membership_subscriptions/Modal'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import permissionService from "../services/permission_service"

export default {
  data() {
    return {
      windowWidth: '',
      permission: permissionService
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  components: {
    MembershipSubscriptionFilter,
    MembershipSubscriptionsTable,
    Modal
  },
  computed: {
    widthResize() {
      return this.windowWidth > 768 ? '50%' : '95%'
    },
    ...mapGetters(['isSubscriptionVisible', 'total', 'queryMembershipSubscription',]),
    getTitle() {
      return 'サブスクリプション会員情報'
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    ...mapMutations('membership_subscription', ['SET_IS_SUBSCRIPTION_VISIBLE']),
    ...mapActions('clinic_customer_note', ['fetchClinicCustomerNotes']),
    ...mapActions('membership_subscription', ['fetchMembershipSubscriptions']),
    ...mapActions('subscription_package', ['fetchSubscriptionPackages']),
    ...mapActions('clinic', ['fetchPointClinics', 'fetchCurrentClinic']),
    async fetchData() {
      await this.fetchCurrentClinic()
      this.fetchMembershipSubscriptions()
      this.fetchSubscriptionPackages()
      this.fetchPointClinics('MembershipSubscriptionRoot')
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    onCloseDialog() {
      this.SET_IS_SUBSCRIPTION_VISIBLE(false)
      document.body.classList.remove('modal-open')
    },
  }
}
</script>

<style>
</style>
